import { memo } from "react";

import { QuestionKidsPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/kids-policy";

import { useRoomKidsPolicy } from "./hooks/use-kids-policy/use-kids-policy";

export const QuestionRoomKidsPolicy = memo(() => {
	const {
		kidsPolicy,
		append,
		canRemoveKidsPolicyItem,
		removeKidsPolicyByIndex,
		getMinAge,
		kidsMaxAgeOptions,
		updateMaxAge,
		discountTypeOptions,
		updateDiscountType,
		ratioOptions,
		updateRatio,
		updateStaticPrice,
	} = useRoomKidsPolicy();

	const label = "部屋独自のキッズポリシー";
	const guide =
		"ホテルポリシーで設定したポリシーと異なるキッズポリシーを設定できます。<br />未設定の場合、ホテルポリシーで設定したキッズポリシーが適用されます。";

	return (
		<QuestionKidsPolicy
			label={label}
			guide={guide}
			appendKidsPolicyItem={append}
			kidsPolicy={kidsPolicy?.value ?? undefined}
			isEdited={kidsPolicy?.isEdited}
			hasError={kidsPolicy?.hasError}
			questionKidsPolicyItemProps={{
				canRemoveKidsPolicyItem,
				kidsPolicyKidsMaxAgeMinAge: getMinAge,
				kidsPolicyKidsMaxAgeOptions: kidsMaxAgeOptions,
				changeKidsPolicyMaxAge: updateMaxAge,
				discountTypeOptions,
				changeKidsPolicyDiscountType: updateDiscountType,
				kidsPolicyRatioOptions: ratioOptions,
				changeKidsPolicyRatio: updateRatio,
				changeKidsPolicyStaticPrice: updateStaticPrice,
				removeKidsPolicyItemByIndex: removeKidsPolicyByIndex,
			}}
		/>
	);
});
